import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { QueryResponse as Risk } from 'api/queries/getRisk.query';

import CustomizedStatusSelect, {
    IOptionComponent,
} from 'components/common/CustomizedStatusSelect/CustomizedStatusSelect';
import Icon from 'components/common/Icons/base/Icon/Icon';

import { TabsSection } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/TabsSection/TabsSection';
import { IStatus } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';
import { statusOptions } from 'components/widgets/RiskRegister/RiskRegister.utils';
import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Tabs/Tabs.module.scss';
import {
    RiskRegisterFormTabs,
    tabsArrData,
} from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Tabs/Tabs.utils';

export const Tabs = ({ activeTab, setActiveTab }) => {
    const { control, setValue } = useFormContext<Risk>();

    return (
        <div className={classes.tabsWithStatusWrapper}>
            <TabsSection<RiskRegisterFormTabs> tabs={tabsArrData} activeTab={activeTab} setActiveTab={setActiveTab} />
            <div className={classes.status}>
                <div className={classes.title}>Status:</div>
                <Controller
                    render={({ field }) => (
                        <CustomizedStatusSelect
                            options={statusOptions}
                            optionValue={statusOptions.find((option) => option.name === field.value)}
                            className={classes.statusCustomSelectContainer}
                            optionComponent={SelectItem}
                            handleChange={(value) => value && setValue('status', value.name, { shouldDirty: true })}
                        />
                    )}
                    name={'status'}
                    control={control}
                />
            </div>
        </div>
    );
};

const SelectItem = ({ item, handleSelect }: IOptionComponent<IStatus>) => {
    return (
        <div
            className={`${classes.statusCustomSelectItem} ${classes[item.name]}`}
            onClick={(e) => {
                handleSelect(item, e);
            }}
        >
            <span>{item.label}</span>
            <div data-testid={'arrow-icon'} className={classes.arrowIconWrapper}>
                <Icon name={'header-arrow-down'} size={'20'} color={'#ffffff'} />
            </div>
        </div>
    );
};
